/**
 * Guarda la lista de participantes a medida que se llena, sin esperar a que
 * se envie el formulario.
 *
 * Alguien llevaba cuarenta miembros cargados, se le cerro la pagina y perdio
 * todo el trabajo: los participantes vivian solo en memoria hasta que se
 * enviaba el modal. Con esto cada vez que se agrega, se quita o se termina de
 * escribir un campo, lo que hay queda guardado.
 *
 * Se escribe con la ruta que toca un solo documento, no con la que reemplaza
 * la columna entera, para no pisar lo que haya en los demas.
 */

/**
 * Deja los participantes como se pueden guardar.
 *
 * La firma puede ser un File mientras no se haya subido, y eso no sobrevive a
 * un JSON: se guarda solo la que ya es una ruta. La firma pendiente se sube
 * igual al enviar el formulario, como siempre.
 */
export const participantesParaGuardar = (participantes: any[]): any[] => {
  const lista = Array.isArray(participantes) ? participantes : [];

  return lista.map((participante) => {
    const { firma, preview, ...resto } = participante ?? {};
    return typeof firma === "string" && firma !== ""
      ? { ...resto, firma }
      : { ...resto };
  });
};

/** Si no hay nada escrito todavia, no vale la pena guardar. */
export const vacio = (participantes: any[]): boolean => {
  const lista = Array.isArray(participantes) ? participantes : [];
  if (lista.length === 0) return true;

  const tieneAlgo = (participante: any) =>
    Object.entries(participante ?? {}).some(([clave, valor]) => {
      if (clave === "nombreGrupo") return false; // se hereda, no lo escribio la persona
      if (valor === null || valor === undefined || valor === "") return false;
      if (typeof valor === "number") return valor !== 0;
      return true;
    });

  return !lista.some(tieneAlgo);
};

/**
 * El documento con la lista de participantes puesta, listo para guardar.
 * Devuelve null si no hay documento al que pegarselos.
 */
export const documentoConParticipantes = (
  documento: any,
  participantes: any[]
): any | null => {
  if (!documento) return null;

  return {
    ...documento,
    participantes: participantesParaGuardar(participantes),
  };
};
